<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowCostPerUnit',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'ha_cogs', throughMonth),
          this.getYtdByField(yearObj, 'net_units_sold', throughMonth),
        );
      },
    },
  };
</script>
